import { render, staticRenderFns } from "./review-email.vue?vue&type=template&id=14405c7e"
import script from "./review-email.vue?vue&type=script&lang=js"
export * from "./review-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports